import Swiper from "swiper";
import { Navigation, Scrollbar } from "swiper/modules";
import "swiper/css";
import "swiper/css/scrollbar";

export class CollectionCarousel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeSwiper();
  }

  initializeSwiper() {
    const swiperContainer = this.querySelector(".swiper");
    const swiperButtonNext = this.querySelector(".swiper-button-next");
    const swiperButtonPrev = this.querySelector(".swiper-button-prev");
    const swiperScrollbar = this.querySelector(".swiper-scrollbar");

    if (
      swiperContainer instanceof HTMLElement &&
      swiperButtonNext instanceof HTMLElement &&
      swiperButtonPrev instanceof HTMLElement &&
      swiperScrollbar instanceof HTMLElement
    ) {
      new Swiper(swiperContainer, {
        modules: [Navigation, Scrollbar],
        navigation: {
          nextEl: swiperButtonNext,
          prevEl: swiperButtonPrev,
        },
        scrollbar: {
          el: swiperScrollbar,
          draggable: true,
        },
        loop: false,
        slidesPerView: parseFloat(this.getAttribute("mobile-items") || "2.5"),
        spaceBetween: 15,
        breakpoints: {
          768: {
            slidesPerView: parseFloat(this.getAttribute("tablet-items") || "4"),
            spaceBetween: 15,
          },
          1068: {
            slidesPerView: parseFloat(
              this.getAttribute("desktop-items") || "6",
            ),
            spaceBetween: 15,
          },
          1268: {
            slidesPerView: parseFloat(
              this.getAttribute("desktop-items") || "8",
            ),
            spaceBetween: 15,
          },
        },
        rewind: true,
      });
    }
  }
}
